/**
 * Adds `keyboard-focus-is-active` class to `body` when user is navigating using keyboard.
 * Removes the class if/when mouse is used. 
 */

export default class KeyboardFocus {
    constructor() {
        this.addEventListeners();
    }

    addEventListeners () {
        window.addEventListener('keydown', () => {
            document.body.classList.add('keyboard-focus-is-active');
        });
        
        window.addEventListener('click', () => {
            document.body.classList.remove('keyboard-focus-is-active');
        });
    }
}
